// Resource limits (D83): the admin page and the task-group page's Resources card.
export default {
  size: (cpus: number, gib: number) => `${cpus} ${cpus === 1 ? "CPU" : "CPUs"} · ${gib} GiB`,
  cpus: "CPUs",
  memory: "Memory (GiB)",
  admin: {
    host: (size: string) => `This host: ${size}. No limit can be larger.`,
    loadFailed: "Could not load the resource limits",
    defaultTitle: "Default",
    defaultHint: "Every user without a role or personal limit gets this. New environments are created at it.",
    rolesTitle: "Roles",
    rolesHint: "A role's limit replaces the default for everyone who holds it.",
    usersTitle: "People",
    usersHint: "A personal limit replaces the role's and the default.",
    usesDefault: "Uses the default",
    noUsers: "No personal limits",
    noUsersBody: "Everyone gets their role's limit or the default.",
    columns: { role: "Role", user: "Person", limit: "Limit" },
    set: "Set",
    addUser: "Add a person",
    editLabel: (name: string) => `Edit the limit for ${name}`,
    setLabel: (name: string) => `Set a limit for ${name}`,
    removeLabel: (name: string) => `Remove the limit for ${name}`,
    readOnly: "You can see the limits; changing them needs the ManageResourceLimits permission.",
    saved: "Limit saved",
    removed: "Limit removed",
  },
  dialog: {
    defaultTitle: "Default limit",
    roleTitle: (role: string) => `Limit for ${role}`,
    userTitle: "Limit for a person",
    person: "Person",
    choosePerson: "Choose a person",
    usersFailed: "Could not load the people list",
    range: (min: number, max: number) => `From ${min} to ${max}`,
    lowered: "Environments above a lowered limit are resized down to it.",
    notSaved: "Not saved",
    fewer: "Fewer CPUs",
    more: "More CPUs",
    fewerMemory: "Less memory",
    moreMemory: "More memory",
  },
  card: {
    title: "Resources",
    description: "The size of this group's environment",
    current: "Current size",
    limit: "Your limit",
    source: { default: "the platform default", role: "your role", user: "set for you" },
    from: (source: string) => `from ${source}`,
    aboveLimit: "This environment is above your limit; applying brings it within it.",
    apply: "Apply",
    applied: "Applied",
    restarting: "Preparing environment — the VM is restarting with its new size.",
    restartingVpn: "A connected VPN drops while it restarts; sign in to it again afterwards.",
    pending: "The new size applies when the current task finishes.",
    loadFailed: "Could not load this environment's size",
    notApplied: "Not applied",
  },
};
